import styled from 'styled-components';

export const PreferencesListV3Styles = styled.div`
  margin: 0 16px;
`;

export const PreferencesListV3ItemStyles = styled.div<{
  imageSrc: string;
  selected: boolean;
}>`
  height: 136px;
  display: grid;
  place-items: center;
  border-radius: 16px;
  background: ${(props) => {
    if (props.selected) {
      return `linear-gradient(270deg, rgba(45, 26, 85, 0.10) 0%, rgba(45, 26, 85, 0.60) 25%, #2D1A55 50%, rgba(45, 26, 85, 0.60) 75%, rgba(45, 26, 85, 0.10) 100%), url(${props.imageSrc})`;
    }
    return `linear-gradient(270deg, rgba(47, 40, 59, 0.10) 0%, rgba(47, 40, 59, 0.60) 25%, #2F283B 50%, rgba(47, 40, 59, 0.60) 75%, rgba(47, 40, 59, 0.10) 100%), url(${props.imageSrc})`;
  }};
  background-size:
    contain,
    350px 172px;
  background-repeat: no-repeat;
  background-position: center, center;

  &:not(:last-child) {
    margin-bottom: 12px;
  }

  ${(props) =>
    props.selected &&
    `
      outline: 2px solid var(--Pheon-Light-Main-Accent, #803eff);
      outline-offset: -2px;
    `}
`;
